const Element = require("components/abstract/Element");
const React = require("react");
const PropTypes = require("prop-types");
const List = require("components/layouts/List");
const assign = require("object-assign");
const {computed} = require("mobx");
const {Decorators: {Injector}} = require("core");
const {Triggers: {Button}} = require("core");

@Injector(["store", "collection"])
class Table extends Element {

    constructor(props) {
        super(props);

        this.state = {
            sorted_col: {},
            collapsed: this.props.defaultCollapsed,
        };
    }

    static get propTypes() {
        return {
            class: PropTypes.string,
            store: PropTypes.any,
            has_folders: PropTypes.bool,
            headless: PropTypes.bool,
            search_column: PropTypes.string,
            anchor_ref: PropTypes.string,
            anchor_title: PropTypes.string,
            button_ref: PropTypes.string,
            button_title: PropTypes.string,
            menu_id: PropTypes.string,
            menu_row_id: PropTypes.string,
            collapseable: PropTypes.bool,
            defaultCollapsed: PropTypes.bool,
        };
    }

    static get defaultProps() {
        return {
            class: '',
            has_folders: false,
            search_column: '',
            anchor_ref: '',
            anchor_title: '',
            button_ref: '',
            button_title: '',
            menu_id: '',
            menu_row_id: '',
            collapseable: false,
            defaultCollapsed: false,
        };
    }

    get defaultClassNames() {
        return [
            'table-advanced',
        	this.state.collapsed ? 'collapsed' : null,
            this.props.store && this.props.store.loadingCollection ? 'loading' : null,
            this.has_data ? '' : 'empty'
        ];
    }

    get collection() {
        if (typeof(this.props.collection) !== 'undefined'
            && this.props.collection !== null
            && (typeof(this.props.collection) === 'object'
                && Object.keys(this.props.collection).length === 0) === false) {
            return this.props.collection;
        }
        return this.props.store.collection;
    }

    get has_data() {
        return this.collection && this.collection.length && this.collection.length > 0;
    }

    get children() {
        return React.Children.toArray(this.props.children);
    }

    get columns() {
        if (this.children.length === 0) {
            return [];
        }

        return React.Children.toArray(this.children[0].props.children);
    }

    get collapseable() {
    	return this.props.collapseable || this.props.defaultCollapsed;
	}

    toggleCollapse = () => {
		this.setState({collapsed: !this.state.collapsed})
    }

    sort = (val) => {
        const dir = val.desc ? 'desc' : 'asc';
        const sort = {
            [val.slug]: dir
        };

        this.props.store.constrain(constraints => assign(constraints, {'$page': 1, '$order': sort}));
    }

    renderTitle() {
    	const content = !this.collapseable ?
			<h5>{this.props.title}</h5> :
			this.renderCollapser();

        return (
            <div className="table-title-block" >
                <div className="title-wrapper flex" >
            		{content}
                </div >
            </div >
        );
    }

    renderCollapser() {
    	if (!this.collapseable) return null;

    	const type = this.state.collapsed ?
    		"arrowDown" :
    		"arrowUp";

		return <Button label={this.props.title} type={type} action={this.toggleCollapse} />;
    }

    renderHeader() {
        if (this.props.headless) {
            return;
        }
        return (
            <thead className="table-header" >
            <tr >
                {this.columns.map(column => {
                    return React.cloneElement(column, {
                        header: true,
                        sort: this.sort,
                        sorted_col: this.state.sorted_col,
                    });
                })}
            </tr >
            </thead >
        );
    }

    renderBodyRows() {
        if (this.has_data) {

            return (
                <List collection={this.collection} menu_id={this.props.menu_id} menu_row_id={this.props.menu_row_id} >
                    {this.children}
                </List >
            )
        }
    }

    renderBody() {
        return (
            <tbody className="table-body" >
            {this.renderBodyRows()}
            </tbody >
        )
    }

    renderFooter() {

    }

    render() {
        return (
            <React.Fragment >
                {this.renderTitle()}
                <table className={this.classNames} >
                    {this.renderHeader()}
                    {this.renderBody()}
                    {this.renderFooter()}
                </table >
            </React.Fragment >
        )
    }

}

module.exports = Table;
